// extracted by mini-css-extract-plugin
var _1 = "_1rV5I";
export { _1 as "base" }
